import { render, staticRenderFns } from "./blog-config.vue?vue&type=template&id=7f29d64a&scoped=true&"
import script from "./blog-config.vue?vue&type=script&lang=js&"
export * from "./blog-config.vue?vue&type=script&lang=js&"
import style0 from "./blog-config.vue?vue&type=style&index=0&id=7f29d64a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f29d64a",
  null
  
)

export default component.exports